var _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    role: "img",
    "aria-label": "Hamburger",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 46h48v3a7 7 0 0 1-7 7H15a7 7 0 0 1-7-7z",
    fill: "#E0A458"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 46h48v2H8z",
    fill: "#C98B3F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 52,
    height: 10,
    rx: 5,
    fill: "#7A3E1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 36,
    width: 52,
    height: 4,
    rx: 2,
    fill: "#8F4C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 33h50v3H40l-6 6-6-6H7z",
    fill: "#FFC93C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29h52v4c-3 0-3 2.5-6.5 2.5S48 33 44.5 33 41 35.5 37.5 35.5 34 33 30.5 33 27 35.5 23.5 35.5 20 33 16.5 33 13 35.5 9.5 35.5 7 33 6 33z",
    fill: "#6BBF59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 50,
    height: 6,
    rx: 3,
    fill: "#E5533D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25.5,
    width: 14,
    height: 1.5,
    rx: 0.75,
    fill: "#F27A66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22C6 13 17 7 32 7s26 6 26 15a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z",
    fill: "#E0A458"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14c4-3.5 11-5 20-5",
    stroke: "#EDBE7C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF3D6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 15,
    rx: 2.2,
    ry: 1.1,
    transform: "rotate(-25 20 15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 12,
    rx: 2.2,
    ry: 1.1,
    transform: "rotate(10 29 12)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 14,
    rx: 2.2,
    ry: 1.1,
    transform: "rotate(-15 38 14)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 18,
    rx: 2.2,
    ry: 1.1,
    transform: "rotate(30 46 18)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 19,
    rx: 2.2,
    ry: 1.1,
    transform: "rotate(20 25 19)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 18.5,
    rx: 2.2,
    ry: 1.1,
    transform: "rotate(-30 34 18.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.e1f6e8bffb7fc38afbc9c4116008767e.svg";
export { ForwardRef as ReactComponent };